import { FC } from "react";

import { Survey } from "typings/api/types";

import SurveyOverview from "./SurveyOverview";

interface Props {
  surveys: Survey[];
  onDeleteSurvey?: (surveyId: string) => void;
}

const SurveyList: FC<Props> = ({ surveys, onDeleteSurvey }) => {
  return (
    <div className="py-ld-32 w-full">
      {surveys.map((survey) => (
        <SurveyOverview key={survey.surveyId} survey={survey} onDeleteSurvey={onDeleteSurvey} />
      ))}
    </div>
  );
};

export default SurveyList;
